import { FC } from "react";

import Button from "../../../../components/Button";
import Modal from "../../../../components/Modal";
import ModalHeader from "../../../../components/Modal/ModalHeader";
import { getFullFrDate } from "../../../../utils/date";

import styles from "./styles.module.scss";

type Props = {
    open: boolean;
    onClose: () => void;
    date: Date | null;
    onChooseTrades: () => void;
    onChooseNoTrades: () => void;
};

const AddSessionChoiceModal: FC<Props> = ({
    open,
    onClose,
    date,
    onChooseTrades,
    onChooseNoTrades,
}) => {
    const label = date ? getFullFrDate(date) : "…";

    return (
        <Modal open={open} onClose={onClose} size="small">
            <div className={styles.content}>
                <div className={styles.titleWrap}>
                    <ModalHeader
                        title={`Ajouter une nouvelle session - ${label}`}
                        handleClose={onClose}
                    />
                </div>
                <div className={styles.actions}>
                    <Button size="large" onClick={onChooseTrades}>
                        Trades
                    </Button>
                    <Button size="large" variant="secondary" onClick={onChooseNoTrades}>
                        No trades
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default AddSessionChoiceModal;
